import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-market-place',
  templateUrl: './market-place.component.html',
  styleUrls: ['./market-place.component.css']
})
export class MarketPlaceComponent implements OnInit {
  public books = [
    {
      Name: "Oxford",
      Type: "Book",
      Star: 3,
      Description: "New Oxford Modern English : Course Book Class 5 – David Horsburgh",
      imgUrl: "https://www.jungle.lk/wp-content/uploads/2019/07/New-Oxford-Modern-English-Course-Book-Class-5-David-Horsburgh.jpg"
    },
    {
      Name: "Oxford",
      Type: "Book",
      Star: 3,
      Description: "Enhance your children’s essential grammar skills with full coverage of the grammar curriculum for Years 1-6 (P2-7), presented in small, easy-to-manage steps.",
      imgUrl: "https://mdgunasena.com/wp-content/uploads/2021/07/10166712-853x1024.jpg"
    },
    {
      Name: "The New Grammar Tree Book 4 Revised Edition",
      Type: "Book",
      Star: 3,
      Description: "THE NEW GRAMMAR TREE FOR CLASS 4 ADDRESSES THE NEED FOR A GRADED, RULE-BASED GRAMMAR COURSE WITH EXTENSIVE EXPLANATIONS AND EXERCISES.",
      imgUrl: "https://mdgunasena.com/wp-content/uploads/2021/06/10178348-ib-853x1024.jpg"
    }
  ]
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/market-place/market-place.component.ts